import { useSelector } from 'react-redux';
import { selectMachines } from '@reducers/machines';
import { useTrackScreenOpened, TRACKING_EVENTS } from '@services/tracking';
import { Machine } from '@interfaces/machines';

export const useTrackPlanboardOpened = () => {
  const machines = useSelector(selectMachines) as Machine[];

  useTrackScreenOpened(TRACKING_EVENTS.PLANBOARD, () => ({
    machineCount: machines?.length || 0,
    totalJobCount: 0,
  }));
};
